import React, { useEffect, lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Lock as LockIcon, Heart as HeartIcon, MessageCircle as MessageCircleIcon, Send as SendIcon, Bookmark as BookmarkIcon, MoreHorizontal as MoreHorizontalIcon } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Avatar } from '../components/Avatar';
import { CtaButton } from '../components/CtaButton';
export function TendePayCaseStudy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <>
      <div className="glow" data-id="element-641"></div>
      <Navbar data-id="element-642" />

      <main className="wrap" data-id="element-643">
        <section className="sec pb-0" data-id="element-644">
          <Link to="/#work" className="mono text-xs uppercase tracking-wider text-mut hover:text-lime transition-colors inline-block mb-10" data-id="element-645">
            ← All work
          </Link>
          <div className="eyebrow mb-6" data-id="element-646">Case Study</div>
          <h1 className="text-6xl md:text-8xl font-bold tracking-tight mb-8" data-id="element-647">
            Tende Pay
          </h1>
          <p className="text-xl md:text-2xl text-mut max-w-3xl leading-relaxed" data-id="element-648">
            A CBK-licensed fintech building digital payment rails that connect
            business people across Africa. We shaped the brand, the marketing
            site, and the product UI around one promise — track and control
            every coin.
          </p>
        </section>

        <section className="sec pt-16" data-id="element-649">
          <div className="stats" data-id="element-650">
            <div className="stat" data-id="element-651">
              <div className="text-xl font-bold text-ink mb-2" data-id="element-652">Tende Pay</div>
              <div className="l" data-id="element-653">Client</div>
            </div>
            <div className="stat" data-id="element-654">
              <div className="text-xl font-bold text-ink mb-2" data-id="element-655">
                Fintech · Payments
              </div>
              <div className="l" data-id="element-656">Industry</div>
            </div>
            <div className="stat" data-id="element-657">
              <div className="text-xl font-bold text-ink mb-2" data-id="element-658">6 weeks</div>
              <div className="l" data-id="element-659">Timeline</div>
            </div>
            <div className="stat" data-id="element-660">
              <div className="text-xl font-bold text-ink mb-2" data-id="element-661">
                Brand · Web · UI/UX
              </div>
              <div className="l" data-id="element-662">Services</div>
            </div>
          </div>
        </section>

        <section className="sec" data-id="element-663">
          <div className="studio" data-id="element-664">
            <div data-id="element-665">
              <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-666">
                The Challenge — fintech has to earn trust in{' '}
                <span className="serif" data-id="element-667">seconds</span>
              </h2>
            </div>
            <div className="text-lg text-mut leading-relaxed space-y-6" data-id="element-668">
              <p data-id="element-669">
                Kenyan businesses run money across M-Pesa, bank, and cash at
                once — and most tools give them almost no visibility into where
                it all goes. Tende Pay set out to fix that, but a payments
                product only works if people trust it on sight. The brand had to
                feel as secure and regulated as it actually is, without turning
                cold or corporate.
              </p>
              <p data-id="element-670">
                Our job was to make something delightful and dependable at the
                same time — a brand and interface that a finance manager and a
                shop owner would both feel at home in.
              </p>
            </div>
          </div>
        </section>

        <section className="sec" data-id="element-671">
          <div className="studio" data-id="element-672">
            <div data-id="element-673">
              <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-674">
                The Approach — one system across brand, site, and{' '}
                <span className="serif" data-id="element-675">app</span>
              </h2>
            </div>
            <div className="text-lg text-mut leading-relaxed space-y-6" data-id="element-676">
              <p data-id="element-677">
                We built the identity around the "tP" monogram and a confident
                orange-and-navy pairing — orange for energy and momentum, navy
                for the security a regulated fintech has to convey. The tone
                leaned into the promise that Tende builds delightful
                experiences, not just infrastructure. That system then carried
                straight into the product: multiple accounts in one place, a
                live balance you can hide, and expenses you can see the moment
                they happen.
              </p>

              <div className="mt-8 flex items-center gap-4" data-id="element-678">
                <div className="flex items-center gap-3" data-id="element-679">
                  <span className="w-9 h-9 rounded-full border border-line-2" style={{
                  background: '#e8641e'
                }} aria-hidden="true" data-id="element-680" />
                  <span className="mono text-xs uppercase tracking-wider text-mut" data-id="element-681">
                    Orange · energy
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-682">
                  <span className="w-9 h-9 rounded-full border border-line-2" style={{
                  background: '#1e2160'
                }} aria-hidden="true" data-id="element-683" />
                  <span className="mono text-xs uppercase tracking-wider text-mut" data-id="element-684">
                    Navy · security
                  </span>
                </div>
              </div>

              <div className="mt-8 space-y-4" data-id="element-685">
                <div className="p-6 border border-line rounded-r-lg bg-raise" data-id="element-686">
                  <h4 className="font-bold text-ink mb-2" data-id="element-687">
                    Your money, your way
                  </h4>
                  <p className="text-base" data-id="element-688">
                    Tag every transaction, record the reason for each payment,
                    and categorise spending without friction.
                  </p>
                </div>
                <div className="p-6 border border-line rounded-r-lg bg-raise" data-id="element-689">
                  <h4 className="font-bold text-ink mb-2" data-id="element-690">
                    Real-time tracking
                  </h4>
                  <p className="text-base" data-id="element-691">
                    Monitor every incoming and outgoing payment across M-Pesa
                    and bank, the moment it lands.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sec" data-id="element-692">
          <figure className="quote max-w-4xl mx-auto" data-id="element-693">
            <blockquote className="q" data-id="element-694">
              "Yetu gave Tende a face people trust in seconds. The brand and the
              app finally feel like the same product —{' '}
              <em data-id="element-695">confident, clear, and genuinely nice to use</em>."
            </blockquote>
            <figcaption className="who" data-id="element-696">
              <Avatar name="Abel" data-id="element-697" />
              <div data-id="element-698">
                <b data-id="element-699">Abel</b>
                <span data-id="element-700">CEO, TendePay</span>
              </div>
            </figcaption>
          </figure>
        </section>

        <section className="sec" data-id="element-701">
          <div className="sec__head mb-12" data-id="element-702">
            <div data-id="element-703">
              <div className="eyebrow mb-5" data-id="element-704">Selected screens</div>
              <h2 data-id="element-705">
                One system, <span className="serif" data-id="element-706">everywhere</span> it lives.
              </h2>
            </div>
          </div>

          {/* Browser mockup — marketing site (landscape) */}
          <figure className="mb-6" data-id="element-707">
            <div className="border border-line-2 rounded-r-lg overflow-hidden bg-raise-2" data-id="element-708">
              <div className="flex items-center gap-3 px-5 py-3.5 border-b border-line" data-id="element-709">
                <span className="flex gap-2" aria-hidden="true" data-id="element-710">
                  <span className="w-3 h-3 rounded-full bg-[#ff5f57]" data-id="element-711" />
                  <span className="w-3 h-3 rounded-full bg-[#febc2e]" data-id="element-712" />
                  <span className="w-3 h-3 rounded-full bg-[#28c840]" data-id="element-713" />
                </span>
                <span className="ml-3 flex items-center gap-2 flex-1 max-w-md mono text-xs text-mut-2 bg-canvas border border-line rounded-full px-4 py-1.5" data-id="element-714">
                  <LockIcon size={12} data-id="element-715" />
                  www.tendepay.com
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/3j7BPN9jAyodYERgHj7ddA/Screenshot_2026-07-03_at_11.51.16.png" alt="Tende Pay marketing site — Own your spend, grow your business" className="w-full h-auto block" loading="lazy" data-id="element-716" />
            </div>
            <figcaption className="mono text-xs uppercase tracking-wider text-mut-2 mt-4" data-id="element-717">
              Marketing site — desktop
            </figcaption>
          </figure>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start" data-id="element-718">
            {/* Phone mockup — app (portrait) */}
            <figure className="flex flex-col items-center" data-id="element-719">
              <div className="relative w-full max-w-[300px] rounded-[42px] border-[10px] border-[#1a1c22] bg-[#1a1c22] shadow-2xl overflow-hidden" data-id="element-720">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-[#1a1c22] rounded-b-2xl z-10" aria-hidden="true" data-id="element-721" />
                <img src="https://cdn.magicpatterns.com/uploads/8tMqhXPNvi6EsYDuKEEuNW/App-1.png" alt="Tende Pay app dashboard showing account balance and recent expenses" className="w-full h-auto block rounded-[32px]" loading="lazy" data-id="element-722" />
              </div>
              <figcaption className="mono text-xs uppercase tracking-wider text-mut-2 mt-6 text-center" data-id="element-723">
                Product app — iOS & Android
              </figcaption>
            </figure>

            {/* Social post mockup — brand poster (square) */}
            <figure className="max-w-[440px] mx-auto w-full" data-id="element-724">
              <div className="border border-line rounded-r-lg overflow-hidden bg-raise" data-id="element-725">
                <div className="flex items-center gap-3 px-4 py-3" data-id="element-726">
                  <img src="https://cdn.magicpatterns.com/uploads/6rp1hbwtu6ALw1oXxiA2Vs/TP_Assets-01.svg" alt="" aria-hidden="true" className="w-9 h-9 rounded-full bg-white object-contain p-1 flex-none" data-id="element-727" />
                  <div className="leading-tight" data-id="element-728">
                    <div className="font-semibold text-sm text-ink" data-id="element-729">
                      tendepay
                    </div>
                    <div className="mono text-[11px] text-mut-2" data-id="element-730">Sponsored</div>
                  </div>
                  <MoreHorizontalIcon size={18} className="ml-auto text-mut" data-id="element-731" />
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/9vt8WLhbSJQqgjyZ3JArC1/Poster_tp1.png" alt="Tende Pay social campaign — We build delightful experiences" className="w-full h-auto block" loading="lazy" data-id="element-732" />
                <div className="px-4 pt-3.5 pb-4" data-id="element-733">
                  <div className="flex items-center gap-5 text-ink" data-id="element-734">
                    <HeartIcon size={22} data-id="element-735" />
                    <MessageCircleIcon size={22} data-id="element-736" />
                    <SendIcon size={22} data-id="element-737" />
                    <BookmarkIcon size={22} className="ml-auto" data-id="element-738" />
                  </div>
                  <div className="mono text-xs text-mut-2 mt-3" data-id="element-739">
                    2,481 likes
                  </div>
                  <p className="text-sm text-mut mt-2 leading-relaxed" data-id="element-740">
                    <span className="font-semibold text-ink" data-id="element-741">tendepay</span>{' '}
                    Digital payment rails that connect business people across
                    Africa. 🧡💙
                  </p>
                </div>
              </div>
              <figcaption className="mono text-xs uppercase tracking-wider text-mut-2 mt-4 text-center" data-id="element-742">
                Brand campaign — social
              </figcaption>
            </figure>
          </div>
        </section>

        <section className="sec" data-id="element-743">
          <div className="sec__head mb-12" data-id="element-744">
            <h2 data-id="element-745">The Results</h2>
          </div>
          <div className="cards" data-id="element-746">
            <div className="card" data-id="element-747">
              <div className="text-4xl font-bold text-lime mb-4" data-id="element-748">1×</div>
              <h3 className="text-xl mb-2" data-id="element-749">Unified system</h3>
              <p data-id="element-750">Across brand, web & app</p>
            </div>
            <div className="card" data-id="element-751">
              <div className="text-4xl font-bold text-lime mb-4" data-id="element-752">6 wks</div>
              <h3 className="text-xl mb-2" data-id="element-753">Launch-ready</h3>
              <p data-id="element-754">From kickoff to delivery</p>
            </div>
            <div className="card" data-id="element-755">
              <div className="text-4xl font-bold text-lime mb-4" data-id="element-756">CBK</div>
              <h3 className="text-xl mb-2" data-id="element-757">Licensed</h3>
              <p data-id="element-758">Regulated, front and centre</p>
            </div>
          </div>
        </section>

        <section className="sec border-t border-line mt-12 pt-24" data-id="element-759">
          <div className="text-center flex flex-col items-center" data-id="element-760">
            <div className="eyebrow mb-6" data-id="element-761">Next Project</div>
            <Link to="/work/novacloud" className="group inline-flex flex-col items-center" data-id="element-762">
              <h2 className="text-5xl md:text-7xl font-bold tracking-tight mb-10 text-ink group-hover:text-lime transition-colors duration-300" data-id="element-763">
                NovaCloud <span className="serif" data-id="element-764">Solutions</span>
              </h2>
            </Link>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-765">
              <CtaButton to="/#contact" variant="pill" data-id="element-766">
                Book Free Consultation
              </CtaButton>
              <CtaButton to="/#work" variant="ghost" data-id="element-767">
                Back to all work
              </CtaButton>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-768" />
    </>;
}